import {DISCUSSIONS_ROUTES as discussionsRoutes} from "@/api/routes";

export const state = () => ({
  discussions: [],
  pagination: {},
  returnDiscussions: [],
  returnResolved: 0,
});

export const getters = {
  discussions: state => state.discussions,
  returnDiscussions: state => state.returnDiscussions,
  returnResolved: state => state.returnResolved,
  pagination: state => state.pagination,
};

export const mutations = {
  SET_DISCUSSIONS(state, discussions) {
    state.discussions = discussions;
  },
  ADD_REPLAY(state, params) {
    state.discussions = state.discussions.map(d =>{
      if (d.discussion_id === params.id)
        d.messages.push(params.message);
      return d;
    })
  },
  ADD_RETURN_REPLAY(state, message) {
    state.returnDiscussions.push(message)
  },
  SET_RETURN_DISCUSSIONS(state, data) {
    state.returnDiscussions = data.messages;
    state.returnResolved = data.resolved;
  },
  SET_PAGINATION(state,pagination){
    delete pagination.data;
    state.pagination = pagination
  },
};

export const actions = {
  async listDiscussions({ commit }, params) {
    return new Promise((resolve, reject) =>{
      this.$api.request(discussionsRoutes.list, {}, params).then(res =>{
        commit('SET_DISCUSSIONS', res.payload.data);
        commit('SET_PAGINATION', res.payload);
        resolve(res);
      }).catch(err =>{
        reject(err);
      })
    })
  },
  async listDiscussionsSendMessage({ commit }, params) {
      return new Promise((resolve, reject) =>{
        this.$api.request(discussionsRoutes.send, {id: params.id}, {message: params.message}).then(res =>{
          commit('ADD_REPLAY', {id: params.id, message:res.payload});
          resolve(res);
        }).catch(err =>{
          reject(err);
        })
      })
  },
  async listReturnDiscussions({ commit }, params) {
    return new Promise((resolve, reject) =>{
      this.$api.request(discussionsRoutes.product_return_chat, {id: params}).then(res =>{
        commit('SET_RETURN_DISCUSSIONS', res.payload);
        resolve(res);
      }).catch(err =>{
        reject(err);
      })
    })
  },
  async listReturnSendMessage({ commit }, params) {
    return new Promise((resolve, reject) =>{
      this.$api.request(discussionsRoutes.product_return_send, {id: params.id}, {message: params.message}).then(res =>{
        // commit('ADD_RETURN_REPLAY', res.payload);
        resolve(res);
      }).catch(err =>{
        reject(err);
      })
    })
  },
};
